import { createSlice } from "@reduxjs/toolkit";
import { userActivityLogAction } from "../action/userActivityLogAction";

export const initialState = {
  selectedUser: null,
  userTransmissionProgressData: null,
  topUserTransmissionProgressData: null,
};

const userActivityLogSlice = createSlice({
  name: "userActivityLog",
  initialState: initialState,
  reducers: userActivityLogAction,
});

export const {
  setSelectedUser,
  setUserTransmissionProgressData,
  setTopUserTransmissionProgressData,
} = userActivityLogSlice.actions;

export default userActivityLogSlice.reducer;
